var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectFile"},[_c('el-button',{staticClass:"fr",attrs:{"type":"default","size":"mini"},on:{"click":_vm.toViewOCR}},[_c('i',{staticClass:"el-icon-search",staticStyle:{"font-size":"14px","margin-right":"5px","z-index":"100000"}}),_vm._v("OCR查看\n\t")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b6e11a3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/discern/control.vue
// module id = null
// module chunks = 